import styled from 'styled-components/macro'

export const SocialsContainer = styled.div`
  background-color: whitesmoke;
`
export const SocialsDiv = styled.div`
  display: flex;
  margin: auto 5rem;
  align-items: center;
  margin: 1rem 0;
  justify-content: space-evenly;
  @media screen and (max-widt: 768px) {
    margin: auto 1rem;
  }
`

export const SocialIcon = styled.img`
  width: 8rem;
  padding: 1.5rem 0;
  margin: 1rem;
  border-radius: 50%;
  transition: 0.3s ease-in-out;
  /* box-shadow: -1rem 1rem 2rem rgba(0, 0, 0, 0.05),
    1rem 1rem 2rem rgba(0, 0, 0, 0.07); */
  &:hover {
    /* transform: translateY(-1.1rem) scale(1.05); */
    filter: drop-shadow(1 0 0.75rem rgba(1, 1, 1));

    transform: translateY(-1.1rem) scale(1.05);
  }

  @media screen and (max-width: 768px) {
    width: 3.5rem;
    margin: 0.3rem;
  }
`
export const Form = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  flex-direction: column;

  width: 50rem;
  margin: 0 auto 3rem auto;

  @media screen and (max-width: 768px) {
    width: 30rem;
  }
  @media only screen and (max-width: 600px) {
    width: 20rem;
  }
`
export const Input = styled.input`
  font-family: 'Lexend Exa', sans-serif;
  font-size: 0.875em;
  width: 100%;
  height: 4rem;
  padding: 0px 15px 0px 15px;
  opacity: 1;
  outline: none;
  color: #111;
  border: solid 2px #b3aca7;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: #dbd5d0;
    ::placeholder {
      color: #1f1f1f;
    }
  }
  &:disabled {
    background: gray;
    border: solid 2px #222;
    opacity: 0.7;
  }
`

// exactly same as input
export const InputTextArea = styled.textarea`
  font-family: 'Lexend Exa', sans-serif;
  font-size: 0.875em;
  width: 100%;
  height: 4rem;
  padding: 0px 1rem 0px 1rem;

  outline: none;
  color: #111;

  border: solid 2px #b3aca7;

  transition: all 0.3s ease-in-out;

  &:hover {
    background: #dbd5d0;
    ::placeholder {
      color: #1f1f1f;
    }
  }
`
export const Label = styled.label`
  color: #1f1f1f;
  font-family: 'Lexend Exa', sans-serif;
  font-size: 1rem;
  margin: 1.5rem 0 0.5rem 0;
`
